import React from 'react';
import './slogan.css';
import endImage from '../../../assets/images/fns-00endv3.png';

const text = "The world is in ruin; salvage yourself."

const Slogan = () => {
  return (
    <div className='papercactus__slogan'>
      <img src={endImage} alt="Fox and Shadow End" className="slogan-image" />
      <h1 className='glitch layers hero mobile-glitch' data-text={text}>
        <span>{text}</span>
      </h1>
    </div>
  );
};

export default Slogan;
